export default {
  state: () => ({
    isLoaderActive: false
  }),
  getters: {
    isLoaderActive: state => state.isLoaderActive
  },
  actions: {
    toggleLoader({ commit }, value = null) {
      commit('TOGGLE_LOADER', value)
    },
  },
  mutations: {
    TOGGLE_LOADER(state, value = null) {
      if (value === null) {
        state.isLoaderActive = !state.isLoaderActive
      } else {
        state.isLoaderActive = value
      }
    }
  },
}
